<template>
    <div class="row">


        <div class=" col-md-12 modal-body-expense" style="padding: 15px;">
            <div class="row" style="padding: 5px;">
                <div class="col-md-12">
                    <div class="alert alert-danger" v-if="errors.length">
                        <strong>Whoops!</strong> There were some problems with your
                        input.<br /><br />
                        <ul>
                            <li v-for="error in errors">{{ error }}</li>
                        </ul>
                    </div>
                    <div class="row">
                        <div class="col-8">
                            <div class="text-left section-title" style="padding: 5px;">
                                <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>
                                    Credit Note for Monthly
                                </span>
                            </div>
                        </div>

                    </div>
                    <div class="row">


                        <div class="col-xs-6 col-sm-6 col-md-6">
                            <div class="form-group">
                                <label>Amount:</label>
                                <input class="form-control"
                                       v-model="payment.amount"
                                       number
                                       data-type="currency" />
                            </div>
                        </div>

                        <div class="col-xs-6 col-sm-6 col-md-6">
                            <div class="form-group">
                                <label>Document Date:</label>
                                <date-picker class="form-control"
                                             :format="customFormatter"
                                             v-model="payment.date" />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-6 col-sm-6 col-md-6">
                            <div class="form-group">
                                <label>Document Number:</label>
                                <input class="form-control" v-model="payment.documentNumber" />
                            </div>
                        </div>

                        <div class="col-xs-6 col-sm-6 col-md-6">
                            <div class="form-group">
                                <label>Description:</label>
                                <input class="form-control" v-model="payment.description" />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-xs-6 col-sm-6 col-md-6">
                            <div class="form-group">
                                <label>Payment Number:</label>
                                <input disabled class="form-control" v-model="payment.documentId" />
                            </div>
                        </div>


                    </div>

                    <div class="col-xs-12 col-sm-12 col-md-12 text-center">
                        <div class="text-center">
                            <button type="submit" @click="save()" class="btn btn-submit" style="margin: 15px;">
                                Submit
                            </button>
                            <button @click="closeModal()" class="btn btn-cancel">Cancel</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { format } from "date-fns";
    export default {
        props: ["buildingId", "paymentId", "amount", "monthly", "monthProp", "period"],
        data: function () {
            return {
                payment: [],
                monthlyFees: [],
                debtors: [],
                building: {},
                building_id: 0,
                month: 0,
                debtor_id: 0,
                date: "2016-10-16",
                errors: [],
                year: 0,
                //monthly:1
            };
        },

        watch: {
            value(val) {
                this.$emit("update:buildingId", val);
            },
            buildingId(val) {
                this.value = val;
                this.payment.amount = undefined;
                this.fetchProperty();
            },
        },
        created() {
            this.payment.documentId = this.paymentId;
            this.payment.amount = this.amount
            this.payment.documentNumber = ''
            this.payment.description = ''
            this.payment.date = this.date
        },
        mounted() {
            this.payment.documentId = this.paymentId;
            this.building_id = this.buildingId;
            if (this.buildingId) this.fetchProperty();
        },

        methods: {
            fetchProperty: async function () {
                /*var request = "/payments/monthly";
                // if(this.route=="home")
                //   request = '/home/statment/get/';
                request = request + "?id=" + this.buildingId;
                this.$http
                  .get(request, {
                    id: this.buildingId,
                  })
                  .then(({ data }) => {
                    this.mute = false;
                    //this.contacts = data.contacts;
                    this.mute = false;
                    // let myObjStr = JSON.stringify(data.expenseFees);
                    this.debtors = data.properties;
                      this.payment = data.payment;
                      if(this.payment.amount == 0)
                          this.payment.amount = undefined
                  });*/
            },
            customFormatter(date) {
                //alert(moment(date).format('dd/MM/YYYY'));
                //return date | moment("dddd, MMMM Do YYYY")
                return format(date, "dd/MM/yyyy");
            },





            closeModal: function () {
                this.$modal.hide("control-panel-add-form");
            },
            checkForm: function (e) {
                this.errors = [];



                if (this.payment.amount <= 0) {
                    this.errors.push("Please enter credit note amount.");
                }

                i

                if (!this.payment.date) {
                    this.errors.push("Please enter credit note date.");
                }



                if (this.errors.length == 0) return;

                e.preventDefault();
            },
            save() {
                //this.checkForm();
                console.log(this.payment.amount)
                console.log(this.payment.documentId)
                console.log(this.payment.documentNumber)
                console.log(this.payment.description)
                console.log(this.date)
                //this.payment.date = this.date
                this.$http
                    .post("/creditnote", {
                        buildingId: this.buildingId,
                        description: this.payment.description,
                        documentId: this.payment.documentId,
                        documentNumber: this.payment.documentNumber,
                        amount: this.payment.amount,
                        date: this.payment.date,
                        monthly: 3,

                    })
                    .then(
                        () => {
                            this.closeModal();
                            location.reload();
                            /*this.$router.push({
                              name: "controlpanel",
                              params: { buildingId: this.buildingId },
                            });*/
                        },
                        () => {
                            alert("error");
                            //  this.infoError = true
                            //  this.loader = false
                            //   this.password = ''
                        }
                    );
            },
        },

        computed: {},
    };
</script>
